module.exports = __webpack_public_path__ + "static/media/course_02.45a904f9.jpg";